import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { loginRedirectGuard } from '../guard/login-redirect.guard';
import { LayoutsComponent } from './layouts/layouts.component';
import { authGuard } from '../guard/auth.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent, canActivate:[loginRedirectGuard] },
    { path: 'auth/forgot-password', component: ForgotPasswordComponent },
    { path: 'auth/reset-password/:token', component: ResetPasswordComponent }, // Dynamic token parameter


    {
        path: 'user',
        component: LayoutsComponent,
        children: [
            {
                path: 'dashboard',
                component: DashboardComponent,
                canActivate:[authGuard]
            },
            {
                path: 'changepassword',
                component: ChangePasswordComponent,
                canActivate:[authGuard]
            },
        ]
    }
];
